<section class="container">
  <div class="page">
    <split-dashboard-menu></split-dashboard-menu>
  </div>
</section>
